import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdStatsAlertsService } from '../../../../../shared/services/ad-stats-alerts.service';
import { StatusRequest } from '../../../../shared/domain/alerts/status-request.model';
import { StatusChange, StatusChangeLabels } from '../../../../shared/domain/alerts/status-change.enum';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cm-widget-status-change',
  template: `
    <cm-widget [menuVisible]="false">
      <cm-widget-title>
        Status change
      </cm-widget-title>
      <cm-widget-content>
        <div class="card-message" [hidden]="!loading">
          <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
        </div>
        <div [hidden]="loading">
          <div *ngFor="let status of statusCount | keyvalue: keepOrder"
               (click)="goToStatusChangePage(status.key)" class="status-change-row">
            <div class="status-change-name"
                 [ngClass]="{'bold status-change-draft': status.key === StatusChange.DRAFT_TO_READY}">
              {{StatusChangeLabels[status.key]}}
            </div>
            <div class="status-change-number"
                 [ngClass]="{'bold status-change-draft': status.key === StatusChange.DRAFT_TO_READY}">{{status.value}}</div>
          </div>
        </div>
      </cm-widget-content>
    </cm-widget>
  `,
  styles: [`
    .status-change-row {
      display: flex;
      justify-content: space-between;
      padding: 0 1.5rem;
      border-bottom: 1px solid #E1E6EC;
      height: 60px;
      align-items: center;
      font-size: 14px;
    }

    .status-change-row:hover {
      background: #f4f6f8;
      cursor: pointer;
    }

    .status-change-number {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #E1E6EC;
      border-radius: 50%;
    }

    .status-change-draft {
      color: #304ffe;
    }
  `]
})
export class WidgetStatusChangeComponent implements OnInit {
  StatusChangeLabels = StatusChangeLabels;
  StatusChange = StatusChange;

  statusCount = {
    [StatusChange.DRAFT_TO_READY]: 0,
    [StatusChange.ACTIVE_TO_INACTIVE]: 0,
    [StatusChange.READY_TO_ACTIVE]: 0
  };

  loading = true;
  sub: Subscription;

  constructor(private router: Router,
              private service: AdStatsAlertsService) {
  }


  ngOnInit() {
    this.refreshData();
  }

  refreshData() {
    const statusRequest = new StatusRequest();
    statusRequest.statusChanges[StatusChange.ACTIVE_TO_INACTIVE] = 7;
    statusRequest.statusChanges[StatusChange.DRAFT_TO_READY] = 7;
    statusRequest.statusChanges[StatusChange.READY_TO_ACTIVE] = 7;

    this.statusCount[StatusChange.ACTIVE_TO_INACTIVE] = 0;
    this.statusCount[StatusChange.DRAFT_TO_READY] = 0;
    this.statusCount[StatusChange.READY_TO_ACTIVE] = 0;

    this.loading = true;
    if (this.sub) {
      this.sub.unsubscribe();
      this.sub = null;
    }
    this.sub = this.service.statusChanges(statusRequest).subscribe(result => {
      result.forEach(item => {
        this.statusCount[item.statusChange]++;
      });
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  goToStatusChangePage(status: StatusChange) {
    this.router.navigate(['/troubleshooting/status-change'], {queryParams: {[status]: 7}});
  }

  keepOrder = (a, b) => {
    return a;
  }
}

